/** 결재 도메인 status 컬러 (Bootstrap BS3 계열) — neutral=임시저장, info=진행중, warning=보류, danger=반려, success=완료 */

export type ApprovalStatusTone =
  | 'neutral'
  | 'info'
  | 'warning'
  | 'danger'
  | 'success';

export const APPROVAL_STATUS_COLOR: Record<ApprovalStatusTone, string> = {
  neutral: '#d6d6d6',
  info: '#61b6d6',
  warning: '#f0ad4e',
  danger: '#d9534f',
  success: '#5cb85c',
};

export const APPROVAL_STATUS_CHIP_INFO_BG = '#428bca';

/** 결재라인 카드 하단 chip ("결재 대기중"/"반려"/"결재 보류중" 등) */
export const APPROVAL_STATUS_CHIP: Record<
  ApprovalStatusTone,
  { bg: string; color: string }
> = {
  neutral: { bg: 'transparent', color: 'var(--dk-text-secondary, #999)' },
  info: { bg: APPROVAL_STATUS_CHIP_INFO_BG, color: '#fff' },
  warning: { bg: APPROVAL_STATUS_COLOR.warning, color: '#fff' },
  danger: { bg: APPROVAL_STATUS_COLOR.danger, color: '#fff' },
  success: { bg: APPROVAL_STATUS_COLOR.success, color: '#fff' },
};

/** 헤더 chip ("결재 진행중 입니다." 등) */
export const APPROVAL_HEADER_CHIP: Record<
  ApprovalStatusTone,
  { bg: string; color: string }
> = {
  neutral: { bg: '#777', color: '#fff' },
  info: { bg: APPROVAL_STATUS_COLOR.info, color: '#fff' },
  warning: { bg: APPROVAL_STATUS_COLOR.warning, color: '#fff' },
  danger: { bg: APPROVAL_STATUS_COLOR.danger, color: '#fff' },
  success: { bg: APPROVAL_STATUS_COLOR.success, color: '#fff' },
};

/** 결재라인 카드 — 강조 비대상의 기본 회색 보더. */
export const APPROVAL_CARD_BORDER_DEFAULT = '#e5e6e9';

/** 결재라인 카드 우상단 순번 chip — 강조 비대상의 기본 회색. */
export const APPROVAL_ORDER_CHIP_DEFAULT = { bg: '#dfe0e4', color: 'var(--dk-text-strong, #666)' };

/** 포탈 status 색(전역 inline 값, 중앙 상수 없음) — 결재라인용 TONE_PALETTE 와 별개 */
export const APPROVAL_STATUS_BADGE: Record<
  ApprovalStatusTone,
  { color: string; bg: string; border: string }
> = {
  neutral: { color: 'var(--dk-text-secondary, #888D96)', bg: 'var(--dk-bg-muted, #F3F5F6)', border: 'var(--dk-line, #E7E9EC)' },
  info: { color: '#436FB1', bg: '#F0F3F9', border: '#D2DCEC' },
  success: { color: '#43B16F', bg: '#F0F9F3', border: '#D2ECDC' },
  danger: { color: 'var(--dk-danger, #F55060)', bg: 'var(--dk-danger-soft, #FEF1F2)', border: 'var(--dk-danger-line, #FDD5D9)' },
  warning: { color: '#EFAE00', bg: '#FFF9EB', border: '#FFECC2' },
};
